import { render, staticRenderFns } from "./AddProjectForm.vue?vue&type=template&id=0c30d558&scoped=true&"
import script from "./AddProjectForm.vue?vue&type=script&lang=js&"
export * from "./AddProjectForm.vue?vue&type=script&lang=js&"
import style0 from "./AddProjectForm.vue?vue&type=style&index=0&id=0c30d558&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c30d558",
  null
  
)

export default component.exports